<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Liên kết với GHTK
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                        </div>

                    </div>
                    <div class="list-partners-component">
                        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                            <span>{{error}}</span>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-center flex-column align-items-center">
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataConnectGHTK.store_id.label"
                                        :id="dataConnectGHTK.store_id.id"
                                        :placeholder="dataConnectGHTK.store_id.placeholder"
                                        :value-default="dataConnectGHTK.store_id.value"
                                        @inputValue="onChange($event, dataConnectGHTK.store_id.id)"
                                        :error-text="dataConnectGHTK.store_id.error"
                                        :is-error="dataConnectGHTK.store_id.isError"
                                        @blur="validateForm($event, dataConnectGHTK.store_id.id)"
                                        :required="dataConnectGHTK.store_id.required"
                                        :disabled="dataConnectGHTK.store_id.disabled"
                                        :options="dataConnectGHTK.store_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataConnectGHTK.token_name.label"
                                        :id="dataConnectGHTK.token_name.id"
                                        :placeholder="dataConnectGHTK.token_name.placeholder"
                                        :value-default="dataConnectGHTK.token_name.value"
                                        @inputValue="onChange($event, dataConnectGHTK.token_name.id)"
                                        :error-text="dataConnectGHTK.token_name.error"
                                        :is-error="dataConnectGHTK.token_name.isError"
                                        :disabled="dataConnectGHTK.token_name.disabled"
                                        @blur="validateForm($event, dataConnectGHTK.token_name.id)"
                                        :required="dataConnectGHTK.token_name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataConnectGHTK.token.label"
                                        :id="dataConnectGHTK.token.id"
                                        :placeholder="dataConnectGHTK.token.placeholder"
                                        :value-default="dataConnectGHTK.token.value"
                                        @inputValue="onChange($event, dataConnectGHTK.token.id)"
                                        :error-text="dataConnectGHTK.token.error"
                                        :is-error="dataConnectGHTK.token.isError"
                                        :disabled="dataConnectGHTK.token.disabled"
                                        @blur="validateForm($event, dataConnectGHTK.token.id)"
                                        :required="dataConnectGHTK.token.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataConnectGHTK.shop_code.label"
                                        :id="dataConnectGHTK.shop_code.id"
                                        :placeholder="dataConnectGHTK.shop_code.placeholder"
                                        :value-default="dataConnectGHTK.shop_code.value"
                                        @inputValue="onChange($event, dataConnectGHTK.shop_code.id)"
                                        :error-text="dataConnectGHTK.shop_code.error"
                                        :is-error="dataConnectGHTK.shop_code.isError"
                                        :disabled="dataConnectGHTK.shop_code.disabled"
                                        @blur="validateForm($event, dataConnectGHTK.shop_code.id)"
                                        :required="dataConnectGHTK.shop_code.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4" v-if="mode === 'create'">
                                <div>
                                    <SelectNormal
                                            :label="dataConnectGHTK.expiration_date.label"
                                            :id="dataConnectGHTK.expiration_date.id"
                                            :placeholder="dataConnectGHTK.expiration_date.placeholder"
                                            :value-default="dataConnectGHTK.expiration_date.value"
                                            @inputValue="onChange($event, dataConnectGHTK.expiration_date.id)"
                                            :error-text="dataConnectGHTK.expiration_date.error"
                                            :is-error="dataConnectGHTK.expiration_date.isError"
                                            @blur="validateForm($event, dataConnectGHTK.expiration_date.id)"
                                            :required="dataConnectGHTK.expiration_date.required"
                                            :options="dataConnectGHTK.expiration_date.options"
                                    ></SelectNormal>
                                </div>
                            </div>
                            <div class="col-sm-4" v-if="mode === 'detail'">
                                <InputTextNormal
                                        :id="dataConnectGHTK.expiration_date.id"
                                        :label="dataConnectGHTK.expiration_date.label"
                                        :disabled="true"
                                        :value-default="dataConnectGHTK.expiration_date.value ?? 'Không bao giờ'"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-2 d-flex flex-column justify-content-end" v-if="mode === 'create'">
                                <ButtonSearchComponent :label="labelButtonSetting" @click="createOrUpdateGHTK"></ButtonSearchComponent>
                            </div>
                            <div class="col-sm-2 d-flex flex-column justify-content-end" v-if="mode === 'detail'">
                                <ButtonSearchComponent :label="labelButtonSetting" @click="redirectToList"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalCalendarComponent @dateSelected="actionDateSelected($event)"></ModalCalendarComponent>
